import React, { useEffect, useState } from 'react';
import { Checkbox, Form, Input, message } from 'antd';
import { Modal } from '../../design-system';
import { BUTTON_PRESETS } from '../../design-system/constants';
import { officeService } from '../../services/officeService';
import { getApiErrorMessage } from '../../utils/errorUtils';

const SupportingDocumentModal = ({ leaveType, onClose, onSaved }) => {
    const [form] = Form.useForm();
    const [saving, setSaving] = useState(false);
    const required = Form.useWatch('required', form);

    useEffect(() => {
        form.setFieldsValue({
            required: leaveType?.attributes?.supportingDocument?.required === true,
            label: leaveType?.attributes?.supportingDocument?.label || 'Medical Certificate (MC)'
        });
    }, [form, leaveType]);

    const save = async () => {
        try {
            const values = await form.validateFields();
            setSaving(true);
            await officeService.updateLeaveTypeSupportingDocument(leaveType.id, {
                required: values.required === true,
                label: values.label?.trim() || null
            });
            message.success('Document requirement updated');
            onSaved();
        } catch (error) {
            if (!error.errorFields) message.error(getApiErrorMessage(error, 'Could not update document requirement'));
        } finally {
            setSaving(false);
        }
    };

    return (
        <Modal visible={Boolean(leaveType)} onClose={onClose} width="medium">
            <Modal.Header title="Document requirement" subtitle={leaveType?.leave_name} />
            <Modal.Body padding="default">
                <Form form={form} layout="vertical">
                    <Form.Item name="required" valuePropName="checked">
                        <Checkbox>Required before approval</Checkbox>
                    </Form.Item>
                    <Form.Item name="label" label="Document label" rules={required ? [
                        { required: true, whitespace: true, message: 'Enter a document label' },
                        { max: 80, message: 'Maximum 80 characters' }
                    ] : [{ max: 80, message: 'Maximum 80 characters' }]}>
                        <Input maxLength={80} placeholder="Medical Certificate (MC)" />
                    </Form.Item>
                    <p>Employees can submit a request without the document, then upload it while the request is pending. Approval will wait for the document.</p>
                </Form>
            </Modal.Body>
            <Modal.Footer buttons={[{
                ...BUTTON_PRESETS.SAVE, key: 'save-document-requirement', label: 'Save',
                loading: saving, onClick: save
            }]} />
        </Modal>
    );
};

export default SupportingDocumentModal;
